module.exports = __webpack_public_path__ + "img/wide.c8c2772c.jpg";